import { Capacitor } from '@capacitor/core';

/**
 * iOS WebView often blocks AudioContext until a user gesture. Prime once on first pointerdown.
 * @returns {Function} cleanup (noop if listener not registered)
 */
export function installMobileAudioGestureUnlock() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return () => {};
  }
  if (!Capacitor.isNativePlatform()) {
    return () => {};
  }
  let done = false;
  const unlock = () => {
    if (done) return;
    done = true;
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    ctx.resume().catch(() => {});
    ctx.close().catch(() => {});
  };
  document.body.addEventListener('pointerdown', unlock, { once: true, passive: true });
  return () => {
    document.body.removeEventListener('pointerdown', unlock);
  };
}
